import { ResourceManager } from "@/components/admin/ResourceManager";

const slugify = (s) =>
  s
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");

export const AdminArticles = () => (
  <ResourceManager
    title="Artikel"
    description="Tulis dan kelola artikel/blog yang tampil di halaman publik /artikel. Slug otomatis dibuat dari judul jika dikosongkan."
    queryKey="articles-admin"
    endpoint="/articles"
    extraInvalidateKeys={["articles-public"]}
    columns={[
      { key: "title", label: "Judul" },
      { key: "slug", label: "Slug" },
      {
        key: "published",
        label: "Status",
        render: (a) => (a.published ? "Terbit" : "Draf"),
      },
    ]}
    fields={[
      {
        name: "title",
        label: "Judul",
        type: "text",
        onChangeExtra: (value, form) => (!form.slug ? { slug: slugify(value) } : {}),
      },
      { name: "slug", label: "Slug URL (huruf kecil, tanpa spasi)", type: "text" },
      { name: "excerpt", label: "Ringkasan Singkat", type: "textarea", rows: 2 },
      {
        name: "content",
        label: "Isi Artikel (mendukung Markdown: **tebal**, ## judul, - daftar, tabel dengan | pemisah)",
        type: "textarea",
        rows: 14,
      },
      { name: "cover_image", label: "Foto Sampul", type: "image" },
      { name: "published", label: "Terbitkan", type: "switch" },
    ]}
  />
);
